export const COMPANY_NAME_CHECK_API =
  "/incorporation_requests/name_available";
export const CREATE_OR_UPDATE_INCORPORATION_REQUEST_API =
  "/incorporation_requests/create_or_update_incorporation_request";
export const CREATE_OR_UPDATE_INCORPORATION_CONTACT_API =
  "/incorporation_requests/create_or_update_incorporation_contact";
export const DELETE_INCORPORATION_CONTACT_API =
  "/incorporation_requests/delete_incorportation_contact";